<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          {{ $t("info.widgets.chart.subscriptions") }}
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2 d-flex justify-space-between"
          >
            {{ $t("subscriptions_report.title")}} {{ this.selectedOrganization !== null ? ' - ' + this.date + ' - ' + this.selectedOrganization.name : ''}}


            <v-btn small color="primary" @click="seeAll()">Ver Todo</v-btn>
          </v-card-title>
          <v-col cols="12" class="d-flex" style="gap:24px" v-if="this.selectedOrganization !== null || this.showAll === true">
            <v-col cols="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="selectedDate"
                transition="scale-transition"
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Seleccione un mes"
                    append-icon="calendar_month"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    style="width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedDate"
                  type="month"
                  :max="getCurrentDate()"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    {{ $t("general.cancel") }}
                  </v-btn>
                  <v-btn text color="primary" @click="handleOK">{{
                    $t("actions.update")
                  }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-col>

          <v-spacer></v-spacer>
          <v-data-table
            :loading="scheduleTable.chargesLoading"
            :headers="scheduleTable.headers"
            :items="scheduleTable.items"
            hide-default-footer
            class="elevation-1"
            :no-data-text="noDataTxt"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center subtitle-1 font-weight-medium">
                  {{
                    item.category === "success"
                      ? $t("subscriptions_report.success")
                      : item.category === "pending"
                      ? $t("subscriptions_report.pending")
                      : item.category === "failed"
                      ? $t("subscriptions_report.failed")
                      : $t("subscriptions_report.failed")
                  }}
                </td>
                <td v-for="(status, index) in item.values" :key="index">
                  {{ status }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col cols="12">
        <v-card>
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            {{ $t("general.organization") }}
          </v-card-title>
          <v-col cols="12" sm="10" md="6" lg="4" class="mb-2">
            <v-text-field
              ref="button-search"
              v-model="organizationsTable.search"
              @input="getAllAfrusEngineOrganizations"
              @click:append="
                table.search ? getAllAfrusEngineOrganizations : null
              "
              :label="$t('actions.search')"
              solo
              flat
              dense
              clearable
              background-color="grey lighten-2"
              append-icon="search"
              hide-details
            />
          </v-col>
          <v-data-table
            :loading="organizationsTable.organizationsLoading"
            :headers="organizationsTable.headers"
            :items="organizationsTable.items"
            :search="organizationsTable.search"
            :custom-filter="tableSearch"
          >
            <template
              v-if="this.organizationsTable.items.length"
              v-slot:body="{ items }"
            >
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  @click="selectOrganization(item)"
                  style="cursor: pointer;"
                >
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          <span>
                            {{ item.id }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>
                            {{ item.name }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>
                            {{ item.contact_name }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>
                            {{ item.contact_info }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>
                            {{ item.phone }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col cols="12">
        <v-card>
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            {{ $t("info.widgets.chart.charges") }}
          </v-card-title>
          <v-row class="ml-2">
            <v-col cols="12" sm="6" md="4" lg="2" class="mb-2">
              <v-text-field
                v-model="chargesTable.search"
                :label="$t('actions.search')"
                solo
                flat
                dense
                clearable
                background-color="grey lighten-2"
                append-icon="search"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-select
                :items="chargesTable.statuses"
                v-model="chargesTable.stateFilter"
                @change="handleStateChange($event)"
                :label="$t('actions.filter_by_status')"
                item-text="name"
                item-value="value"
                solo
                flat
                dense
                background-color="grey lighten-2"
                hide-details
                clearable
              />
            </v-col>
          </v-row>
          <v-data-table
            :loading="scheduleTable.chargesLoading"
            :search="chargesTable.search"
            :headers="chargesTable.headers"
            :items="filteredItems"
            :footer-props="{ 'items-per-page-options': [5, 10, 25, 50, 100] }"
            :no-data-text="noDataTxt"
            :custom-filter="chargesTableSearch"
          >
            <template v-if="filteredItems.length" v-slot:item="{ item }">
              <tr
                class="cursor-pointer text-no-wrap"
                @click="openChargeDetails(item)"
              >
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{ item.id }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{
                            item.subscription
                              ? item.subscription.id
                              : "-"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{
                            item.subscription_gateway_code
                              ? item.subscription_gateway_code
                              : "-"
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-medium"
                        :style="{
                          color: getStateForColor(item.state),
                          'font-weight': getStateForFontWeight(item.state)
                        }"
                        :class="[getStateForTextColor(item.state)]"
                      >
                        <span>
                          {{ getStateByNumber(item.state) }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{ item.created_at | moment("DD/MM/YYYY") }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{ item.updated_at | moment("DD/MM/YYYY") }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{
                            item.state === 2 ? item.subscription.next_payment_date : (item.state === 4 ? item.next_payment_date : '-')
                              | moment("DD/MM/YYYY")
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{ item.lead.email }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
                <td>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span>
                          {{ item.organization.name }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-navigation-drawer
      :value="isChargesDetailsOpen"
      @input="inputChargeDetails"
      width="800px"
      max-width="100vw"
      temporary
      fixed
      right
      color="grey lighten-3"
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
    >
      <v-card
        v-if="isChargesDetailsOpen"
        min-height="100vh"
        color="grey lighten-3"
      >
        <BaseToolbar
          :title="$t('subscriptions_report.charge_details')"
          @close="closeChargeDetails"
          :primaryColor="true"
        />
        <div class="d-flex justify-center">
          <v-card class="rounded-2 mt-6" width="85%">
            <div class="py-12 px-6">
              <VueJsonPretty :data="chargeSelected" />
              <!-- <template>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="body-2 font-weight-bold">
                      Respuesta
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pa-0">
                      <v-divider />
                      <v-card-text>
                        <v-container>
                          <v-row dense>
                            <v-col cols="12">
                              <VueJsonPretty
                                :data="chargeSelected.gatawey_json_response"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template> -->
            </div>
          </v-card>
        </div>
      </v-card>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import DonationMixin from "@/mixins/donations";

export default {
  name: "SubscriptionsReport",
  mixins: [DonationMixin],
  components: { VueJsonPretty, BaseToolbar },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t("subscriptions_report.breadcrumb"),
          disabled: false
        },
        {
          text: this.$t("subscriptions_report.title"),
          disabled: true,
          href: ""
        }
      ],
      date: `${(new Date()).getFullYear()}-${(new Date()).getMonth() + 1}`,
      menu: false,
      selectedDate: null,
      selectedOrganization: null,
      scheduleTable: {
        chargesLoading: false,
        headers: [],
        items: []
      },
      showAll: false,
      chargesTable: {
        chargesLoading: false,
        items: [],
        total: 0,
        search: null,
        statuses: [
          { name: "success", value: 2 },
          { name: "pending", value: 4 },
          {
            name: "failed",
            value: 5
          }
        ],
        stateFilter: null,
        pagination: {
          sortBy: ["created_at"],
          sortDesc: [false],
          itemsPerPage: 10
        },
        headers: [
          {
            text: "ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: "Subscription Gateway Code",
            value: "gateway_code",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("subscriptions_report.charges_table.state"),
            value: "state",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },

          {
            text: this.$t("subscriptions_report.charges_table.created_at"),
            value: "created_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("subscriptions_report.charges_table.updated_at"),
            value: "updated_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.next_payment"),
            value: "next_payment_date",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Lead",
            value: "lead_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.organization"),
            value: "organization_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      },

      organizationsTable: {
        organizationsLoading: false,
        items: [],
        search: null,
        total: 0,
        pagination: {
          sortBy: ["name"],
          sortDesc: [false]
        },
        headers: [
          {
            text: "ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("organization.table.org_name"),
            value: "name",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("organization.table.org_contact_name"),
            value: "contact_name",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("organization.table.org_contact_info"),
            value: "contact_info",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("organization.table.org_phone"),
            value: "phone",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      },
      chargeSelected: null,
      isChargesDetailsOpen: false
    };
  },
  async mounted() {
    //this.scheduleTable.chargesLoading = true;
    this.organizationsTable.organizationsLoading = true;
    //this.chargesTable.chargesLoading = true;
    await this.getAllAfrusEngineOrganizations();
    //await this.setScheduleTableValues();
  },
  watch: {
    date: {
      handler: "setScheduleTableValues"
    },
    "organizationsTable.pagination": {
      handler() {
        this.getAllAfrusEngineOrganizations();
      },
      deep: true
    },
    selectedOrganization: {
      handler: "setScheduleTableValues"
    }
  },
  computed: {
    ...mapState({
      afrusEngineOrganizations: ({
        afrusEngine: { afrusEngineOrganizations }
      }) => afrusEngineOrganizations,
      totalOrganizations: ({ afrusEngine: { totalOrganizations } }) =>
        totalOrganizations,
      subscriptionsReport: ({ afrusEngine: { subscriptionsReport } }) =>
        subscriptionsReport,
      charges: ({ afrusEngine: { charges } }) => charges
    }),
    noDataTxt(){
      return this.selectedOrganization === null ? this.$t("subscriptions_report.select_org") : this.$t("subscriptions_report.no_data")
    },
    filteredItems() {
      if (this.chargesTable.search) {
        const query = this.chargesTable.search.toLowerCase();

        return this.chargesTable.items.filter(
          item =>
            item.lead.email.toLowerCase().includes(query) ||
            item.organization.name.toLowerCase().includes(query)
        );
      } else if (this.chargesTable.stateFilter) {
        const state = this.chargesTable.stateFilter;
        return this.chargesTable.items.filter(item => item.state === state);
      } else if (this.chargesTable.search && this.chargesTable.stateFilter) {
        const query = this.chargesTable.search.toLowerCase();
        const state = this.chargesTable.stateFilter;

        return this.chargesTable.items.filter(
          item =>
            item.lead.email.toLowerCase().includes(query) ||
            item.organization.name.toLowerCase().includes(query) ||
            item.state === state
        );
      } else {
        return this.chargesTable.items;
      }
    }
  },
  methods: {
    ...mapActions({
      getAfrusEngineOrganizations: "afrusEngine/getAfrusEngineOrganizations",
      getSubscriptionsReport: "afrusEngine/getSubscriptionsReport"
    }),
    async setScheduleTableValues() {
      this.scheduleTable.chargesLoading = true;
      const organization_id = this.selectedOrganization
        ? this.selectedOrganization.id
        : null;

      const now = `${(new Date()).getFullYear()}-${(new Date()).getMonth() + 1}`

      const date = !!this.date ? this.date : now;
      await this.getSubscriptionsReport({ date, organization_id });

      const daysInMonth = this.subscriptionsReport.success.length;

      const headers = Array.from({ length: daysInMonth }, (_, i) => ({
        text: (i + 1).toString(),
        value: i + 1,
        sortable: false,
        class: "text-no-wrap blue--text text--darken-4"
      }));
      headers.unshift({
        text: this.$t("afrus_engine.table.charge_success"),
        sortable: false,
        class: "text-no-wrap blue--text text--darken-4"
      });

      const rows = Object.entries(this.subscriptionsReport).map(
        ([key, value]) => ({
          category: key,
          values: value
        })
      );

      this.scheduleTable.headers = headers;
      this.scheduleTable.items = rows;
      this.scheduleTable.chargesLoading = false;

      this.chargesTable.items = this.charges;
      this.chargesTable.total = parseInt(this.charges.length, 10);
      this.chargesTable.chargesLoading = false;
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 2;
      return `${year}-${month < 10 ? "0" + month : month}`;
    },
    resetValues() {
      this.date = null;
      this.selectedOrganization = null;
    },
    handleOK() {
      this.date = this.selectedDate;
      this.$refs.menu.save(this.selectedDate);
    },

    async getAllAfrusEngineOrganizations() {
      let { sortBy, sortDesc = false } = this.organizationsTable.pagination;
      const { search } = this.organizationsTable;
      if (Array.isArray(sortBy)) {
        [sortBy] = sortBy;
      }
      if (Array.isArray(sortDesc)) {
        [sortDesc] = sortDesc;
      }

      await this.getAfrusEngineOrganizations({
        search,
        sortBy: sortBy || "id",
        descending: sortDesc
      });

      this.organizationsTable.items = this.afrusEngineOrganizations;
      this.organizationsTable.total = parseInt(this.totalOrganizations, 10);
      this.organizationsTable.organizationsLoading = false;
    },
    selectOrganization(item) {
      this.selectedOrganization = item;
    },
    openChargeDetails(item) {
      this.chargeSelected = item;
      this.isChargesDetailsOpen = true;
    },
    closeChargeDetails() {
      this.isChargesDetailsOpen = false;
      this.chargeSelected = null;
    },

    inputChargeDetails(arg) {
      if (!arg) {
        this.isChargesDetailsOpen = false;
      }
    },
    handleStateChange(event) {
      this.chargesTable.stateFilter = event;
    },
    async seeAll(){
      this.scheduleTable.chargesLoading = true;
      
      await this.setScheduleTableValues();
      this.selectOrganization = null
      this.showAll = true
      this.scheduleTable.chargesLoading = false;
    },
    tableSearch(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        item.id.toString().indexOf(search) !== -1 ||
        item.name.toString().indexOf(search) !== -1 
      );
    },
    chargesTableSearch (value, search, item) {
      let stringValue = value.toString()
        return stringValue != null &&
          stringValue != null &&
          item.id.toString().indexOf(search) !== -1 ||
          item.lead.email.toString().indexOf(search) !== -1 
      },
  }
};
</script>

<style lang="scss" scoped></style>
